export const FIELDS = {
  ID: 'id',
  COMPANY_ID: 'companyId',
  NAME: 'name',
  CONTACT_ID: 'contactId',
  CONTACT_FULL_NAME: 'contactFullName',
  PART_ID: 'partId',
  PART_NUMBER: 'partNumber',
  MFG_NAME: 'mfgName',
  NSNNUMBER: 'nsnNumber',
  AS_PERCENT: 'asPercent',
  PERCENT_OF_SALE: 'percentOfSale',
  PRICE_PER_UNIT: 'pricePerUnit',
  HARMONIZED_CODE: 'harmonizedCode',
  SCHEDULE_B: 'scheduleB',
  ECCN: 'eccn',
  MANUFACTURER_ID: 'manufacturerId',
  DESCRIPTION: 'description',
  INVENTORY_CATEGORY_ID: 'inventoryCategoryId',
  CATEGORY_NAME: 'categoryName',
  INVENTORY_CLASS_ID: 'inventoryClassId',
  CLASS_NAME: 'className',
  UO_MID: 'uoMId',
  UOM: 'uom',
  PACKAGE_ID: 'packageId',
  PACKAGE: 'package',
  PHYS_PKG: 'physPkg',
  PIECE_PER_PKG: 'piecePerPkg',
  LEAD_FREE: 'leadFree',
  PART_COMMENTS: 'partComments',
  COMMENTS: 'comments',
  CREATED_BY_USER_ID: 'createdByUserId',
  CREATED_BY_USER_FULL_NAME: 'createdByUserFullName',
  MODIFIED_BY_USER_ID: 'modifiedByUserId',
  MODIFIED_BY_USER_FULL_NAME: 'modifiedByUserFullName',
  DATE_CREATED: 'dateCreated',
  DATE_MODIFIED: 'dateModified',
  ACTIVE: 'active',};